import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/{fieldKey}/re-run-questionnaire-agent']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];

const rerunQuestionnaireAgentOnQuestionnaireField = async ({
  fieldKey,
  questionnaireId,
  externalDataSetIds,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/{fieldKey}/re-run-questionnaire-agent', {
    fieldKey,
    questionnaireId,
  });
  const data = await formsBackendClient.post(path, { externalDataSetIds });
  return data.data;
};

export default rerunQuestionnaireAgentOnQuestionnaireField;
